/***
 *
 *   SEARCH STYLES
 *   Ported from ui-reference/src/components/ui/search-input.tsx — a leading
 *   icon at left-3 with pl-10 on a h-9 field, not a trailing button.
 *
 **********/

const Style = {
    base: 'relative w-full',
    icon: 'pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-text-muted',
    input: `flex h-9 w-full rounded-md border border-input bg-surface pl-10 pr-9 text-sm text-text-primary shadow-sm
    placeholder:text-text-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring
    disabled:cursor-not-allowed disabled:opacity-50`,

    // Clear affordance, kept from the previous implementation.
    clear: 'absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer text-text-muted transition-colors hover:text-text-primary',
};

export default Style;
